module.exports = __webpack_public_path__ + "static/media/flag-checkered.f1ebf3c3.svg";